import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateEventRegistrationResponsesFilter } from './useEventRegistrationResponsesFilter';
import { invalidateEventRegistrationStats } from './useEventRegistrationStats';
import { IManualRegistrationRequest, IManualRegistrationResponse } from './useManualRegistrationMutation';

export const useUpdateRegistrationMutation = ({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data?: IManualRegistrationResponse) => void;
}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			surveyId,
			responseId,
			request,
		}: {
			surveyId: string;
			responseId: string;
			request: IManualRegistrationRequest;
		}) => {
			return userSession.webServiceHelper.callAsync<IManualRegistrationResponse>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `survey/eventRegistration/${surveyId}/manualRegistration/${responseId}`,
				}),
				'PUT',
				request
			);
		},
		onSuccess: (data, variables) => {
			invalidateEventRegistrationResponsesFilter();
			invalidateEventRegistrationStats(variables.surveyId);
			onSuccess?.(data);
		},
		onError,
	});
};
